var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { fetchConfig } from '../ProductRecoSlider/config';
import BrandItem from './BrandItem';
import DefaultCard from '../Card';
import { LazyProvider, useLazyLoad } from '../LazyLoad';
import { Link } from '../Link';
import Slider from '../Slider';
import usePapiData from '../hooks/usePapiData';
import useGraphQL from '../hooks/useGraphQL';
import withErrorBoundary from '../higherOrderComponents/withErrorBoundary';
var StyledLink = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  & > * {\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    text-decoration: none;\n    margin: 0;\n    padding: 0.5rem;\n    font-size: 0.688rem;\n\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"], ["\n  height: 100%;\n  & > * {\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    text-decoration: none;\n    margin: 0;\n    padding: 0.5rem;\n    font-size: 0.688rem;\n\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.greyLight.color.normal;
});
/**
 * Slider config for BrandRecoSlider
 */
var sliderConfig = function (cardLayout, lazyLoad) { return ({
    styleType: cardLayout ? 'type2' : 'default',
    lazyLoad: lazyLoad,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    progressBar: false,
    responsive: [
        { breakpoint: 300, settings: { slidesToShow: 2.5, slidesToScroll: 3 } },
        { breakpoint: 480, settings: { slidesToShow: 4.5, slidesToScroll: 3 } },
        { breakpoint: 700, settings: { slidesToShow: 5.5, slidesToScroll: 4 } },
        { breakpoint: 800, settings: { slidesToShow: 6.5, slidesToScroll: 5 } },
        { breakpoint: 960, settings: { slidesToShow: 7.5, slidesToScroll: 6 } },
        { breakpoint: 1200, settings: { slidesToShow: 7.5, slidesToScroll: 6 } },
        { breakpoint: 1500, settings: { slidesToShow: 8.5, slidesToScroll: 8 } },
    ],
}); };
var UnlazyBrandRDE = function (props) {
    var recoApi = props.recoApi, cid = props.cid, allBrandsLink = props.allBrandsLink, headline = props.headline, usePapi = props.usePapi;
    var wasVisible = useLazyLoad();
    var apiLocale = useIntl().locale;
    var papiBrands = usePapiData('hotBrandsIntraday');
    var _a = useGraphQL(usePapi ? 'prudsysCategoryToBrandsPapi' : 'prudsysCategoryToBrands', {
        cid: cid,
        locale: apiLocale,
        papibrands: papiBrands,
    }, {
        url: wasVisible ? recoApi : '',
        fetchConfig: __assign({}, fetchConfig),
    }), error = _a.error, isLoading = _a.isLoading, response = _a.response, areParamsSufficient = _a.areParamsSufficient;
    var _b = useState({
        brands: [
            {
                image: '',
                name: 'Something went wrong...',
                cid: 0,
                url: '#',
                includedInCategories: [0],
                trackingToken: '',
                parentName: '',
            },
        ],
        error: '',
    }), fetchedData = _b[0], setFetchedData = _b[1];
    useEffect(function () {
        var _a;
        if ((response === null || response === void 0 ? void 0 : response.data) && ((_a = response.data.prudsysCategoryToBrands.brands) === null || _a === void 0 ? void 0 : _a.length)) {
            setFetchedData(response.data.prudsysCategoryToBrands);
        }
    }, [response]);
    useEffect(function () {
        if (error && wasVisible) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [wasVisible, error]);
    if (!areParamsSufficient) {
        // eslint-disable-next-line no-console
        console.error('Props are not sufficient - RDE is not being rendered');
        return React.createElement(React.Fragment, null);
    }
    // GraphQL error (e.g. needed sid cookie is not available)
    if (fetchedData.error) {
        // eslint-disable-next-line no-console
        console.error(fetchedData.error);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Slider, __assign({}, sliderConfig(true, true), { headline: isLoading ? 'Loading...' : headline, lazyLoad: false }),
            isLoading && wasVisible ? (React.createElement("div", null, "Loading...")) : (fetchedData.brands.map(function (brand, idx) { return (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement(DefaultCard, { key: "Marke-" + brand.cid + "-" + idx },
                React.createElement(BrandItem, __assign({}, brand)))); })),
            React.createElement(DefaultCard, null,
                React.createElement(StyledLink, null,
                    React.createElement(Link, { to: allBrandsLink }, "Alle Marken anzeigen"))))));
};
/**
 * <p style="display:none;">
 *  Props are destructered here and given a default value, so Storybook can show the default value in their prop table.
 * </p>
 * <p>
 *  This slider shows brand recommendations. To use it, you just have to import it in your file and pass down the needed props.
 * </p>
 * <p>
 *  Right now the slider needs to have a <mark>headline</mark> and an url to the all brands page (<mark>allBrandsLink</mark>) for the respective tenant as prop,
 *  because prudsys does not provide these currently.
 * </p>
 */
export var BrandRecoSlider = function (_a) {
    var _b = _a.allBrandsLink, allBrandsLink = _b === void 0 ? '' : _b, _c = _a.cid, cid = _c === void 0 ? '' : _c, _d = _a.headline, headline = _d === void 0 ? '' : _d, _e = _a.recoApi, recoApi = _e === void 0 ? '' : _e, _f = _a.usePapi, usePapi = _f === void 0 ? false : _f;
    return (React.createElement(LazyProvider, null,
        React.createElement(UnlazyBrandRDE, { allBrandsLink: allBrandsLink, cid: cid, headline: headline, recoApi: recoApi, usePapi: usePapi })));
};
export default withErrorBoundary(BrandRecoSlider, function () { return null; });
var templateObject_1;
//# sourceMappingURL=index.js.map